import React, {useContext} from "react";
import { Text, View } from "@/styles/reactnative";
import {ThemeContext} from "@/theme/ThemeProvider.tsx";

const BankInfo = ({ text, theme = true }: any) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;

  return (
    <View style={{ lineHeight: 1, alignItems: "center" }}>
      <Text
        style={
          theme
            ? {
                justifyContent: "center",
              }
            : { justifyContent: "center", color: textw }
        }
      >
        {text}
      </Text>
    </View>
  );
};

export default React.memo(BankInfo);
